<template>
    <div class="confirms">
        <Popup :value="show"  :close-on-click-overlay="false">
            <div class="box">
                <div class="content">
                    <div class="title">{{ title }}</div>
                    <div class="msg">{{ msg }}</div>
                </div>
                <div class="group-Btn">
                    <Button class="btn cancel" @click="$emit('cancel')">{{ cancelButtonText }}</Button>
                    <Button class="btn confirm" :class="{'studio-btn': isStudio}" @click="$emit('confirm')">{{ confirmButtonText }}</Button>
                </div>
            </div>
        </Popup>
    </div>
</template>

<script>
    import { Popup, Button } from 'vant';
    export default {
        name: 'Confirm',
        props: {
            show:Boolean,
            title: {
                type: String,
                default: '提示'
            },
            msg: {
                type: String,
                default: ''
            },
            confirmButtonText: {
                type: String,
                default: '确定'
            },
            cancelButtonText: {
                type: String,
                default: '取消'
            },
            isStudio: {
                type: Boolean,
                default: false
            },
        },
        data:function () {
            return {
            }
        },
        methods:{

        },
        components:{Popup, Button}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .confirms{
        .van-popup{
            border-radius: 5px;
        }
        .box{
            width: 295px;
            padding: 20px 24px;
            display: flex;
            flex-direction: column;
            align-items: center;

            overflow: hidden;
            .content{
                text-align: center;
                width: 100%;
                padding: 20px 0 20px;
                color: #222;
                .title{
                    font-size: 19px;
                    margin-bottom: 20px;
                }
                .msg{
                    font-size: 15px;
                }
            }
            .group-Btn{
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: space-between;
                .btn{
                    width: 114px;
                    height: 40px;
                    border-radius: 20px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 16px;
                    border: none;
                }
                .cancel{
                    color: #6B7993;
                    border: 1px solid #969FA9;
                }
                .confirm {
                    background: #FF5555;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    &.studio-btn {
                        background: #FEDB07;
                        color: #222222;
                    }
                }
            }
        }
    }

</style>
